import React, { useContext } from "react";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { Link, Tag, Text } from "@foris/avocado-suite";
import { GroupContext } from "../../context/GroupContext";
import { IContextApp, ContextApp } from "@config/Context/contextApp";
import { getAdaptedReference } from "@services/collections/references/referencesAdapters";
import css from "./reference.module.scss";

export type ReferenceType = {
  value: string;
  label: string;
};

export interface ReferenceProps {
  onEdit?: () => void;
}

const Reference: React.FC<ReferenceProps> = ({ onEdit }) => {
  const { t } = useTranslation();
  const { state } = useContext(GroupContext);
  const context: IContextApp = useContext(ContextApp);

  const [userPermissions] = [context?.user?.permissions, context?.user?.abilities];
  const userCanEdit = userPermissions?.update;
  const userCanCreate = userPermissions?.create;
  const isDisabled = !(userCanEdit && userCanCreate);

  return (
    <section className={cx(css.cntReference)}>
      <div className={css.cntReference_actions}>
        <span className={css.actionsTitle}>Referencias</span>

        <Link
          className={css.actionsButton}
          iconLeft="edit"
          disabled={isDisabled}
          onClick={onEdit}
          size="sm"
        >
          {t("generals.edit")}
        </Link>
      </div>

      <section className={cx(css.tagsSection, "avocado-dark-theme")}>
        {state?.info?.info?.references?.map(ref => (
          <Tag key={ref.id} className={css.tagsSection_tag}>
            <Text weight="medium">{getAdaptedReference(ref)?.customLabel ?? ref?.value}</Text>
          </Tag>
        ))}
      </section>
    </section>
  );
};

export default Reference;
